import { SplitPaymentReceipts } from "./SplitPaymentReceipts";
export default SplitPaymentReceipts;